const DEFAULT_KEY = 'default';
// invalidCombination rules
const SELA_EXCLUSIVE_ROLES = 'SELAExclusiveRoles';

var Programs;
(function (Programs) {
    Programs["Elementary"] = "k5SelDigital";
    Programs["OutOfSchool"] = "ostKit";
    Programs["MiddleSchool"] = "mspDigital";
    Programs["HighSchool"] = "highSchool";
    Programs["SELA"] = "sela";
    Programs["EarlyLearning"] = "elSelKit";
    Programs["K5Kit"] = "k5SelKit";
    Programs["MiddleSchoolKit"] = "mspKit";
    Programs["AccessSSPKit"] = "sspKit";
    Programs["BPUKit"] = "bpuKit";
    Programs["AccessBPUTraining"] = "bpuDigital";
    Programs["CPUKit"] = "cpuKit";
    Programs["AccessCPUTraining"] = "cpuDigital";
    Programs["FieldTestSELA"] = "fTsela";
})(Programs || (Programs = {}));
var Grades;
(function (Grades) {
    Grades["EarlyLearning"] = "E";
    Grades["GradeK"] = "K";
    Grades["Grade1"] = "1";
    Grades["Grade2"] = "2";
    Grades["Grade3"] = "3";
    Grades["Grade4"] = "4";
    Grades["Grade5"] = "5";
    Grades["Grade6"] = "6";
    Grades["Grade7"] = "7";
    Grades["Grade8"] = "8";
    Grades["HighSchool"] = "highschool";
    Grades["Adult"] = "adult";
})(Grades || (Grades = {}));
var Roles;
(function (Roles) {
    Roles["Administrator"] = "admin";
    Roles["Coordinator"] = "coordinator";
    Roles["Teacher"] = "teacher";
    Roles["Family"] = "family";
    Roles["LeaderTeam"] = "leader";
    Roles["Staff"] = "staff";
    Roles["Public"] = "public";
})(Roles || (Roles = {}));
var OptInUnits;
(function (OptInUnits) {
    OptInUnits["BullyingHarassment"] = "MS: Bullying Unit on";
    OptInUnits["BullyingHarassmentOff"] = "MS: Bullying Unit off";
})(OptInUnits || (OptInUnits = {}));
var Activities;
(function (Activities) {
    Activities["HighSchoolStudentActivitiesOn"] = "HS student activities on";
    Activities["HighSchoolStudentActivitiesOff"] = "HS student activities off";
})(Activities || (Activities = {}));
class Audiences {
    constructor(isDefault, programs, grades, roles, implementationLevels, mindYeti, optInUnits, activities) {
        this.isDefault = isDefault;
        this.programs = programs;
        this.grades = grades;
        this.roles = roles;
        this.implementationLevels = implementationLevels;
        this.mindYeti = mindYeti;
        this.optInUnits = optInUnits;
        this.activities = activities;
    }
    toKey() {
        var _a, _b, _c, _d, _e;
        if (this.isDefault) {
            return DEFAULT_KEY;
        }
        let key = '';
        key += this.programs.length ? `programs:${this.programs.join(',')}-` : '';
        key += this.grades.length ? `grades:${this.grades.join(',')}-` : '';
        key += this.roles.length ? `roles:${this.roles.join(',')}-` : '';
        key += ((_a = this.implementationLevels) === null || _a === void 0 ? void 0 : _a.length)
            ? `implementation:${this.implementationLevels.join(',')}-`
            : '';
        key += this.mindYeti !== undefined ? `mindYeti:${this.mindYeti}-` : '';
        // TODO: add other optInUnits values as they are defined
        key +=
            ((_b = this.optInUnits) === null || _b === void 0 ? void 0 : _b.length) &&
                this.optInUnits.includes(OptInUnits.BullyingHarassment)
                ? `bullyingHarassment:true-`
                : '';
        key +=
            ((_c = this.optInUnits) === null || _c === void 0 ? void 0 : _c.length) &&
                this.optInUnits.includes(OptInUnits.BullyingHarassmentOff)
                ? `bullyingHarassment:false-`
                : '';
        // TODO: add other activities values as they are defined
        key +=
            ((_d = this.activities) === null || _d === void 0 ? void 0 : _d.length) &&
                this.activities.includes(Activities.HighSchoolStudentActivitiesOn)
                ? `highSchoolActivities:true-`
                : '';
        key +=
            ((_e = this.activities) === null || _e === void 0 ? void 0 : _e.length) &&
                this.activities.includes(Activities.HighSchoolStudentActivitiesOff)
                ? `highSchoolActivities:false-`
                : '';
        // slice of the last '-' character:
        return key.substring(0, key.length - 1);
    }
    static create(plainObject) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (plainObject.isDefault) {
            return Audiences.DEFAULT;
        }
        return new Audiences(false, (_b = (_a = plainObject.programs) === null || _a === void 0 ? void 0 : _a.sort()) !== null && _b !== void 0 ? _b : [], (_d = (_c = plainObject.grades) === null || _c === void 0 ? void 0 : _c.sort()) !== null && _d !== void 0 ? _d : [], (_f = (_e = plainObject.roles) === null || _e === void 0 ? void 0 : _e.sort()) !== null && _f !== void 0 ? _f : [], (_k = (_h = (_g = plainObject.implementationLevel) === null || _g === void 0 ? void 0 : _g.sort()) !== null && _h !== void 0 ? _h : (_j = plainObject.implementationLevels) === null || _j === void 0 ? void 0 : _j.sort()) !== null && _k !== void 0 ? _k : undefined, (_l = plainObject.mindYeti) !== null && _l !== void 0 ? _l : undefined, (_o = (_m = plainObject.optInUnits) === null || _m === void 0 ? void 0 : _m.sort()) !== null && _o !== void 0 ? _o : undefined, (_q = (_p = plainObject.activities) === null || _p === void 0 ? void 0 : _p.sort()) !== null && _q !== void 0 ? _q : undefined);
    }
    static restoreFromDatabase(serializedAudience) {
        const coercedAudience = serializedAudience;
        try {
            return Audiences.create(coercedAudience);
        }
        catch (_a) {
            return undefined;
        }
    }
}
Audiences.DEFAULT = new Audiences(true, [], [], []);

const WEIGHTS = {
    programs: {
        [Programs.K5Kit]: 1,
        [Programs.MiddleSchool]: 1,
        [Programs.Elementary]: 1,
        [Programs.OutOfSchool]: 1,
        [Programs.HighSchool]: 1,
        [Programs.SELA]: 1,
        [Programs.EarlyLearning]: 1,
        [Programs.MiddleSchoolKit]: 1,
        [Programs.AccessSSPKit]: 1,
        [Programs.BPUKit]: 1,
        [Programs.AccessBPUTraining]: 1,
        [Programs.CPUKit]: 1,
        [Programs.AccessCPUTraining]: 1,
        [Programs.FieldTestSELA]: 1,
    },
    roles: {
        [Roles.Teacher]: 3,
        [Roles.Administrator]: 5,
        [Roles.Coordinator]: 5,
        [Roles.Family]: 2,
        [Roles.LeaderTeam]: 4,
        [Roles.Staff]: 3,
        [Roles.Public]: 1,
    },
    grades: {
        [Grades.EarlyLearning]: 1,
        [Grades.GradeK]: 1,
        [Grades.Grade1]: 1,
        [Grades.Grade2]: 1,
        [Grades.Grade3]: 1,
        [Grades.Grade4]: 1,
        [Grades.Grade5]: 1,
        [Grades.Grade6]: 1,
        [Grades.Grade7]: 1,
        [Grades.Grade8]: 1,
        [Grades.HighSchool]: 1,
        [Grades.Adult]: 1,
    },
    mindYeti: 1,
    isDefault: 0,
    implementationLevels: {
        [1]: 1,
        [2]: 1,
        [3]: 1,
    },
    optInUnits: {
        [OptInUnits.BullyingHarassment]: 1,
        [OptInUnits.BullyingHarassmentOff]: 1,
    },
    activities: {
        [Activities.HighSchoolStudentActivitiesOn]: 1,
        [Activities.HighSchoolStudentActivitiesOff]: 1,
    },
};
/**
 * Returns the weight for a given audience.
 *
 * @remarks
 * This currently supports only object and boolean fields.
 * We may need to update this function if we add other singular values to the audience.
 *
 * @param audience - audience to check the weight
 * @returns The weight of audience
 *
 */
function getWeight(audience) {
    let totalWeight = 0;
    for (const key in audience) {
        if (isIterable(audience[key])) {
            for (const val of audience[key]) {
                totalWeight += WEIGHTS[key][val];
            }
        }
        else {
            if (audience[key] === true) {
                totalWeight += WEIGHTS[key];
            }
        }
    }
    return totalWeight;
}
const isIterable = (x) => !!(x === null || x === void 0 ? void 0 : x[Symbol.iterator]);

const invalidCombinations = [
    {
        ruleName: SELA_EXCLUSIVE_ROLES,
        programs: [Programs.SELA],
        roles: [Roles.Staff, Roles.LeaderTeam],
    },
];
var MatchMode;
(function (MatchMode) {
    MatchMode[MatchMode["All"] = 0] = "All";
    MatchMode[MatchMode["Any"] = 1] = "Any";
})(MatchMode || (MatchMode = {}));
const matchPermissionsField = (dataPermissions, userPermissions, mode = MatchMode.All) => {
    // if data field is not set, it's a non-constraint, always match
    if (!dataPermissions) {
        return true;
    }
    // if all of the entries on data permissions are false, treat as though there is no requirement for this field:
    if (dataPermissions.length === 0) {
        return true;
    }
    // if a user constraint is not set, don't match
    if (userPermissions === undefined) {
        return false;
    }
    if (mode === MatchMode.All) {
        // all data permissions must be matched:
        const matchedPermissions = dataPermissions.filter((dataPermission) => userPermissions.includes(dataPermission));
        return matchedPermissions.length === dataPermissions.length;
    }
    else {
        // any data permission may be matched:
        for (const dataPerm of dataPermissions) {
            if (userPermissions.includes(dataPerm)) {
                return true;
            }
        }
        return false;
    }
};
const matchValueField = (dataValue, userValue) => {
    // if data field is not set, it's a non-constraint, always match
    if (!dataValue) {
        return true;
    }
    // if a user constraint is not set, don't match
    if (!userValue) {
        return false;
    }
    return dataValue === userValue;
};
// export for testability
const audiencesMatch = (dataAudience, userAudience, matchMode = MatchMode.All) => {
    var _a;
    // if audiences field doesn't exist on data, assume this data is for all audiences
    if (!dataAudience || ((dataAudience === null || dataAudience === void 0 ? void 0 : dataAudience.isDefault) && (userAudience === null || userAudience === void 0 ? void 0 : userAudience.isDefault))) {
        return true;
    }
    if (!userAudience) {
        return false;
    }
    // equivalent to exclusive or (dataAudience.isDefault XOR userAudience.isDefault)
    if (((dataAudience === null || dataAudience === void 0 ? void 0 : dataAudience.isDefault) && !(userAudience === null || userAudience === void 0 ? void 0 : userAudience.isDefault)) ||
        (!(dataAudience === null || dataAudience === void 0 ? void 0 : dataAudience.isDefault) && (userAudience === null || userAudience === void 0 ? void 0 : userAudience.isDefault))) {
        return false;
    }
    const programMatch = matchPermissionsField(dataAudience.programs, userAudience.programs, matchMode);
    const rolesMatch = matchPermissionsField(dataAudience.roles, userAudience.roles, matchMode);
    const gradesMatch = matchPermissionsField(dataAudience.grades, userAudience.grades, matchMode);
    const implementationLevelMatch = matchPermissionsField(
    // @ts-ignore: add this hack to address a bug in the data where implementationLevel is singular in Contentful
    (_a = (dataAudience.implementationLevels || dataAudience.implementationLevel)) === null || _a === void 0 ? void 0 : _a.map(lvl => parseInt(lvl)), userAudience.implementationLevels, matchMode);
    const mindYetiMatch = matchValueField(dataAudience.mindYeti, userAudience.mindYeti);
    const bullyingHarassmentMatch = matchPermissionsField(dataAudience.optInUnits, userAudience.optInUnits, matchMode);
    const activitiesMatch = matchPermissionsField(dataAudience.activities, userAudience.activities, matchMode);
    return (programMatch &&
        rolesMatch &&
        gradesMatch &&
        implementationLevelMatch &&
        mindYetiMatch &&
        bullyingHarassmentMatch &&
        activitiesMatch);
};
const filterForAudience = (contentfulData, userAudiences) => {
    if (!contentfulData) {
        return undefined;
    }
    if (!audiencesMatch(contentfulData.audiences, userAudiences, MatchMode.Any)) {
        return undefined;
    }
    // make a copy of the data so we're not mutating the original object
    const mutatedData = structuredClone(contentfulData);
    for (const key in mutatedData) {
        if (key === 'audiences' || typeof mutatedData[key] !== 'object') {
            continue;
        }
        mutatedData[key] = filterForAudience(mutatedData[key], userAudiences);
        // handle cases where the return payload is undefined
        if (!mutatedData[key]) {
            delete mutatedData[key];
        }
        // filter out unmatched items in array entries:
        if (Array.isArray(mutatedData[key])) {
            mutatedData[key] = mutatedData[key].filter((item) => !!item);
        }
    }
    return mutatedData;
};
const matchesInvalidCombination = (aud) => {
    var _a, _b;
    for (const invalid of invalidCombinations) {
        // hacky, kind of hardcoded way to enforce that for SELA, only one role can be selected:
        if (invalid.ruleName === SELA_EXCLUSIVE_ROLES) {
            const containsRoles = (_a = invalid.roles) === null || _a === void 0 ? void 0 : _a.map((role) => aud.roles.includes(role)).every((x) => x);
            const containsPrograms = (_b = invalid.programs) === null || _b === void 0 ? void 0 : _b.map((program) => aud.programs.includes(program)).every((x) => x);
            if (containsRoles && containsPrograms) {
                return true;
            }
        }
    }
    return false;
};
// export for testability
const generatePermutations = (aud) => {
    var _a, _b, _c, _d, _e, _f;
    let programRequired = false;
    let gradeRequired = false;
    let roleRequired = false;
    const keyValuePairs = [];
    for (const program in (_a = aud.programs) !== null && _a !== void 0 ? _a : {}) {
        keyValuePairs.push(['programs', program]);
        programRequired = true;
    }
    for (const role in (_b = aud.roles) !== null && _b !== void 0 ? _b : {}) {
        keyValuePairs.push(['roles', role]);
        roleRequired = true;
    }
    for (const grade in (_c = aud.grades) !== null && _c !== void 0 ? _c : {}) {
        keyValuePairs.push(['grades', grade]);
        gradeRequired = true;
    }
    for (const implementationLevel in (_d = aud.implementationLevels) !== null && _d !== void 0 ? _d : {}) {
        keyValuePairs.push(['implementationLevels', parseInt(implementationLevel)]);
    }
    for (const optInUnit in (_e = aud.optInUnits) !== null && _e !== void 0 ? _e : {}) {
        keyValuePairs.push(['optInUnits', optInUnit]);
    }
    for (const activity in (_f = aud.activities) !== null && _f !== void 0 ? _f : {}) {
        keyValuePairs.push(['activities', activity]);
    }
    if (aud.mindYeti === true) {
        keyValuePairs.push(['mindYeti', true]);
    }
    const results = [];
    function permute(index, current) {
        if (index === keyValuePairs.length) {
            if (Object.keys(current).length > 0) {
                results.push(Audiences.create(current));
            }
            return;
        }
        const [key, value] = keyValuePairs[index];
        // Include the field
        const includePermutation = structuredClone(current);
        if ([
            'programs',
            'grades',
            'roles',
            'implementationLevels',
            'optInUnits',
            'activities',
        ].includes(key)) {
            // @ts-expect-error: allow this hack because we know the type should be an array
            includePermutation[key] = (current[key] || []).concat(value);
        }
        else {
            includePermutation[key] = value;
        }
        permute(index + 1, includePermutation);
        // Exclude the field
        const excludePermutation = structuredClone(current);
        permute(index + 1, excludePermutation);
    }
    permute(0, {});
    const validResults = results.filter((aud) => !matchesInvalidCombination(aud));
    return validResults.filter((aud) => {
        if (programRequired && aud.programs.length === 0) {
            return false;
        }
        if (gradeRequired && aud.grades.length === 0) {
            return false;
        }
        if (roleRequired && aud.roles.length === 0) {
            return false;
        }
        return true;
    });
};
const isKnownListKey = (key) => {
    return (key === 'programs' ||
        key === 'grades' ||
        key === 'roles' ||
        key === 'implementationLevels' ||
        key === 'optInUnits' ||
        key === 'activities');
};
const mergeAudiencePermutations = (perm1, perm2) => {
    const merged = {
        programs: {},
        grades: {},
        roles: {},
        implementationLevels: {},
        mindYeti: false,
        optInUnits: {},
        activities: {},
    };
    if (perm1.mindYeti || perm2.mindYeti) {
        merged.mindYeti = true;
    }
    for (const key in perm1) {
        if (isKnownListKey(key)) {
            // @ts-expect-error: allow this hack because we know keys are valid
            for (const subKey in perm1[key]) {
                // @ts-expect-error: allow this hack because we know keys are valid
                merged[key][subKey] = true;
            }
        }
    }
    for (const key in perm2) {
        if (isKnownListKey(key)) {
            // @ts-expect-error: allow this hack because we know keys are valid
            for (const subKey in perm2[key]) {
                // @ts-expect-error: allow this hack because we know keys are valid
                merged[key][subKey] = true;
            }
        }
    }
    return merged;
};
// navigates a tree of Contentful data and generates a list of all potential audiences
const getAvailableAudiences = (contentfulData) => {
    if (!contentfulData) {
        return [];
    }
    // recursive function to generate all possible permutations of audiences in a tree
    function getAudiencePermutations(contentfulData) {
        var _a, _b, _c, _d, _e, _f;
        let permutations = {
            programs: {},
            grades: {},
            roles: {},
            implementationLevels: {},
            mindYeti: false,
            optInUnits: {},
            activities: {},
        };
        for (const key in contentfulData) {
            if (key === 'audiences' ||
                typeof contentfulData[key] !== 'object' ||
                !contentfulData[key]) {
                continue;
            }
            permutations = mergeAudiencePermutations(permutations, getAudiencePermutations(contentfulData[key]));
        }
        if (contentfulData === null || contentfulData === void 0 ? void 0 : contentfulData.audiences) {
            if (contentfulData.audiences.mindYeti) {
                permutations.mindYeti = true;
            }
            for (const program of (_a = contentfulData.audiences.programs) !== null && _a !== void 0 ? _a : []) {
                // @ts-expect-error: allow this hack because we know keys are valid
                permutations.programs[program] = true;
            }
            for (const grade of (_b = contentfulData.audiences.grades) !== null && _b !== void 0 ? _b : []) {
                // @ts-expect-error: allow this hack because we know keys are valid
                permutations.grades[grade] = true;
            }
            for (const role of (_c = contentfulData.audiences.roles) !== null && _c !== void 0 ? _c : []) {
                // @ts-expect-error: allow this hack because we know keys are valid
                permutations.roles[role] = true;
            }
            for (const implementationLevel of (_d = contentfulData.audiences // NOTE: this is purposefully singular to match how it is in Contentful:
                .implementationLevel) !== null && _d !== void 0 ? _d : []) {
                // @ts-expect-error: allow this hack because we know keys are valid
                permutations.implementationLevels[implementationLevel] = true;
            }
            for (const optInUnit of (_e = contentfulData.audiences.optInUnits) !== null && _e !== void 0 ? _e : []) {
                // @ts-expect-error: allow this hack because we know keys are valid
                permutations.optInUnits[optInUnit] = true;
            }
            for (const activity of (_f = contentfulData.audiences.activities) !== null && _f !== void 0 ? _f : []) {
                // @ts-expect-error: allow this hack because we know keys are valid
                permutations.activities[activity] = true;
            }
        }
        return permutations;
    }
    const permutations = getAudiencePermutations(contentfulData);
    return [Audiences.DEFAULT, ...generatePermutations(permutations)];
};
// this function will use a set of rules to determine if the user has multiple permissions for a field which one takes precendence
// for example, roles: ['admin', 'teacher'] => 'admin'
// returns undefined if no matching audience is found
const getSignificantAudience = (userAudience, availableAudiences) => {
    if (userAudience === null || userAudience === void 0 ? void 0 : userAudience.isDefault) {
        return Audiences.DEFAULT;
    }
    // return the default audience if there is no other match:
    let significantAudience = Audiences.DEFAULT;
    let maxWeight = -1;
    if (availableAudiences.length) {
        for (const available of availableAudiences) {
            if (audiencesMatch(available, userAudience)) {
                const weight = getWeight(available);
                if (weight > maxWeight) {
                    significantAudience = available;
                    maxWeight = weight;
                }
            }
        }
    }
    return significantAudience;
};

const encodeUserContext = (userContext) => {
    return btoa(JSON.stringify(userContext));
};
const decodeUserContext = (base64EncodedUserContext) => {
    return JSON.parse(atob(base64EncodedUserContext));
};
const convertUserContextToAudiences = (userContext, activeSiteId) => {
    // TODO: actually validate the userContext is in a valid shape
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    // TODO: when location and preferences are added to anonymous user context, we should NOT just return default audience
    if (!userContext.sites || userContext.sites.length === 0) {
        return Audiences.DEFAULT;
    }
    // if activeSiteId is not specified, assume sites[0] is the active site
    const activeSite = userContext.sites.find((site) => site.siteId === activeSiteId) ||
        userContext.sites[0];
    const programs = Object.keys((_a = activeSite.programs) !== null && _a !== void 0 ? _a : {});
    const roles = ((_b = activeSite.claims) !== null && _b !== void 0 ? _b : []).filter((role) => Object.values(Roles).includes(role));
    const grades = [];
    const implementationLevels = new Set();
    for (const program in activeSite.programs) {
        const programData = activeSite.programs[program];
        if (!programData) {
            continue;
        }
        if ((_c = programData.preferences) === null || _c === void 0 ? void 0 : _c.implementationLevel) {
            implementationLevels.add(programData.preferences.implementationLevel);
        }
        for (const course of (_d = programData.courses) !== null && _d !== void 0 ? _d : []) {
            grades.push(course.name);
        }
    }
    for (const pak in (_e = userContext.paks) !== null && _e !== void 0 ? _e : {}) {
        const pakData = (_f = userContext === null || userContext === void 0 ? void 0 : userContext.paks) === null || _f === void 0 ? void 0 : _f[pak];
        if (!pakData) {
            continue;
        }
        for (const grade in pakData.grades) {
            // @ts-expect-error this is a valid indexing of the grades object but TypeScript won't recognize it
            const rolesData = pakData.grades[grade];
            if (!rolesData) {
                continue;
            }
            for (const role of rolesData.claims) {
                if (!roles.includes(role) && Object.values(Roles).includes(role)) {
                    roles.push(role);
                }
            }
        }
    }
    let mindYeti = undefined;
    if ((_j = (_h = (_g = activeSite.programs) === null || _g === void 0 ? void 0 : _g.k5SelDigital) === null || _h === void 0 ? void 0 : _h.preferences) === null || _j === void 0 ? void 0 : _j.mindYeti) {
        mindYeti = activeSite.programs.k5SelDigital.preferences.mindYeti === true;
    }
    const optInUnits = [];
    if ((_l = (_k = activeSite.programs) === null || _k === void 0 ? void 0 : _k.mspDigital) === null || _l === void 0 ? void 0 : _l.preferences) {
        const preferences = activeSite.programs.mspDigital.preferences;
        if (preferences.bullyingHarassmentUnitEnabled === true) {
            optInUnits.push(OptInUnits.BullyingHarassment);
        }
        // explicitly check for the false value, if this setting is undefined or missing, don't add it to the optInUnits array:
        else if (preferences.bullyingHarassmentUnitEnabled === false) {
            optInUnits.push(OptInUnits.BullyingHarassmentOff);
        }
    }
    const activities = [];
    if ((_o = (_m = activeSite.programs) === null || _m === void 0 ? void 0 : _m.highSchool) === null || _o === void 0 ? void 0 : _o.preferences) {
        const preferences = activeSite.programs.highSchool.preferences;
        if (preferences.studentActivities === true) {
            activities.push(Activities.HighSchoolStudentActivitiesOn);
        }
        // explicitly check for the false value, if this setting is undefined or missing, don't add it to the activities array:
        else if (preferences.studentActivities === false) {
            activities.push(Activities.HighSchoolStudentActivitiesOff);
        }
    }
    return Audiences.create({
        isDefault: false,
        programs,
        grades,
        roles,
        implementationLevels: implementationLevels.size
            ? Array.from(implementationLevels)
            : undefined,
        mindYeti,
        optInUnits,
        activities,
    });
};

export { Audiences, Grades, Programs, Roles, convertUserContextToAudiences, decodeUserContext, encodeUserContext, filterForAudience, getAvailableAudiences, getSignificantAudience };
//# sourceMappingURL=index.esm.js.map
